export enum BACKOFFICE_API_CONTROLLERS {
  MEMBERSHIP = 'membership'
}
